import template from './mapFilterPage.html';
import controller from './mapFilterPage.controller';
import './mapFilterPage.scss';

let mapFilterPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default mapFilterPageComponent;
